import React from 'react';
import { useRouter } from '@atlassian/react-resource-router';
import { useBacklogActionCreator, useBacklogSelector } from '../../state';
import { setLastSelectedCardKey } from '../../state/actions/cards/selection';
import { setAllPanels } from '../../state/actions/panels';
import { getIsCompanyManaged } from '../../state/selectors/app';
import { getLastSelectedCard } from '../../state/selectors/cards';
import { SyncWithRouting, type Props } from './view';

const SyncWithRoutingContainer = () => {
	const lastSelectedCardId = useBacklogSelector(getLastSelectedCard);
	const setLastSelectedCardKeyAction = useBacklogActionCreator(setLastSelectedCardKey);
	const setAllPanelsAction = useBacklogActionCreator(setAllPanels);
	const [{ action, location }] = useRouter();
	const isCompanyManaged = useBacklogSelector(getIsCompanyManaged);
	const props: Props = {
		lastSelectedCardId,
		setLastSelectedCardKey: setLastSelectedCardKeyAction,
		setAllPanels: setAllPanelsAction,
		action,
		location,
		isCompanyManaged,
	};
	return <SyncWithRouting {...props} />;
};

export default SyncWithRoutingContainer;
